<div
  class="homepage-banner"
  [class.iframe-widget]="widgetService.brandIframeWidget$ | async"
>
  <!-- Overlay -->
  <div
    class="banner--overlay"
    *ngIf="!(service.hiptravelerBrand$ | async) && !loader"
  ></div>

  <!-- Background Image -->
  <img class="banner--background"
    [lazyLoad]="(service.brandCampaign$ | async)?.cCoverImg?.cover || ''"
    defaultImage="assets/img/blank.webp"
    errorImage="assets/img/blank.webp"
    [alt]="(service.brandCampaign$ | async)?.cHashtag"
    [ngClass]="{ 'loaded': !loader }"
    (onStateChange)="lazyloadStateChangeFn($event)"
  />

  <!-- Skeleton Loader -->
  <div class="banner--skeleton" [ngClass]="{ 'loading': loader }">
    <ngx-skeleton-loader
      count="1"
      appearance="line"
      animation="pulse"
    ></ngx-skeleton-loader>
  </div>

  <!-- Banner Content -->
  <ng-container *ngIf="service.brandCampaign$ | async as brandCampaign">
    <div class="banner--content" [ngClass]="{ 'banner--brand--content': brandCampaign.cId != 'hiptraveler' }">

      <div class="banner--headline" [ngClass]="{ 'banner--headline-brand': brandCampaign.cId != 'hiptraveler' }">
        <h1 class="headline-with-dot" [ngClass]="{ 'headline-with-dot-brand': brandCampaign.cId != 'hiptraveler' }">
          {{ brandCampaign | headline1 | async }}
        </h1>

        <h2>
          {{ brandCampaign | headline2 | async }}
        </h2>
      </div>

      <!-- <div
        class="banner--apple-container"
        *ngIf="brandCampaign.cId === 'hiptraveler'">
        <a class="banner--apple" target="_blank" href="https://testflight.apple.com/join/9hBH9Wjx">
          <img
            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
            alt="Download HipTraveler app on the App Store"
          />
        </a>
      </div> -->

    </div>
    <div class="banner--information" *ngIf="service.hiptravelerBrand$ | async">
        <p><a target="_blank" href="https://nomadfestcreator.com/agenda">
            NomadFest | Creator Edition
        </a></p>
      </div>
  </ng-container>
</div>
